var _excluded = ["__scopeProgress", "value", "max", "getValueLabel"],
  _excluded2 = ["__scopeProgress"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var $1DGzP$babelruntimehelpersextends = require("@babel/runtime/helpers/extends");
var $1DGzP$react = require("react");
var $1DGzP$radixuireactcontext = require("@radix-ui/react-context");
var $1DGzP$radixuireactprimitive = require("@radix-ui/react-primitive");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "createProgressScope", function () {
  return $66e9ff9cece0fdb5$export$388eb2d8f6d3261f;
});
$parcel$export(module.exports, "Progress", function () {
  return $66e9ff9cece0fdb5$export$b25a304ec7d746bb;
});
$parcel$export(module.exports, "ProgressIndicator", function () {
  return $66e9ff9cece0fdb5$export$2b776f7e7ee60dbd;
});
$parcel$export(module.exports, "Root", function () {
  return $66e9ff9cece0fdb5$export$be92b6f5f03c0fe9;
});
$parcel$export(module.exports, "Indicator", function () {
  return $66e9ff9cece0fdb5$export$adb584737d712b70;
});

/* -------------------------------------------------------------------------------------------------
 * Progress
 * -----------------------------------------------------------------------------------------------*/
var $66e9ff9cece0fdb5$var$PROGRESS_NAME = 'Progress';
var $66e9ff9cece0fdb5$var$DEFAULT_MAX = 100;
var _$1DGzP$radixuireactc = $1DGzP$radixuireactcontext.createContextScope($66e9ff9cece0fdb5$var$PROGRESS_NAME),
  _$1DGzP$radixuireactc2 = _slicedToArray(_$1DGzP$radixuireactc, 2),
  $66e9ff9cece0fdb5$var$createProgressContext = _$1DGzP$radixuireactc2[0],
  $66e9ff9cece0fdb5$export$388eb2d8f6d3261f = _$1DGzP$radixuireactc2[1];
var _$66e9ff9cece0fdb5$va = $66e9ff9cece0fdb5$var$createProgressContext($66e9ff9cece0fdb5$var$PROGRESS_NAME),
  _$66e9ff9cece0fdb5$va2 = _slicedToArray(_$66e9ff9cece0fdb5$va, 2),
  $66e9ff9cece0fdb5$var$ProgressProvider = _$66e9ff9cece0fdb5$va2[0],
  $66e9ff9cece0fdb5$var$useProgressContext = _$66e9ff9cece0fdb5$va2[1];
var $66e9ff9cece0fdb5$export$b25a304ec7d746bb = /*#__PURE__*/$1DGzP$react.forwardRef(function (props, forwardedRef) {
  var __scopeProgress = props.__scopeProgress,
    valueProp = props.value,
    maxProp = props.max,
    _props$getValueLabel = props.getValueLabel,
    getValueLabel = _props$getValueLabel === void 0 ? $66e9ff9cece0fdb5$var$defaultGetValueLabel : _props$getValueLabel,
    progressProps = _objectWithoutProperties(props, _excluded);
  var max = $66e9ff9cece0fdb5$var$isValidMaxNumber(maxProp) ? maxProp : $66e9ff9cece0fdb5$var$DEFAULT_MAX;
  var value = $66e9ff9cece0fdb5$var$isValidValueNumber(valueProp, max) ? valueProp : null;
  var valueLabel = $66e9ff9cece0fdb5$var$isNumber(value) ? getValueLabel(value, max) : undefined;
  return /*#__PURE__*/$1DGzP$react.createElement($66e9ff9cece0fdb5$var$ProgressProvider, {
    scope: __scopeProgress,
    value: value,
    max: max
  }, /*#__PURE__*/$1DGzP$react.createElement($1DGzP$radixuireactprimitive.Primitive.div, $parcel$interopDefault($1DGzP$babelruntimehelpersextends)({
    "aria-valuemax": max,
    "aria-valuemin": 0,
    "aria-valuenow": $66e9ff9cece0fdb5$var$isNumber(value) ? value : undefined,
    "aria-valuetext": valueLabel,
    role: "progressbar",
    "data-state": $66e9ff9cece0fdb5$var$getProgressState(value, max),
    "data-value": value !== null && value !== void 0 ? value : undefined,
    "data-max": max
  }, progressProps, {
    ref: forwardedRef
  })));
});
/*#__PURE__*/
Object.assign($66e9ff9cece0fdb5$export$b25a304ec7d746bb, {
  displayName: $66e9ff9cece0fdb5$var$PROGRESS_NAME
});
$66e9ff9cece0fdb5$export$b25a304ec7d746bb.propTypes = {
  max: function max(props, propName, componentName) {
    var propValue = props[propName];
    var strVal = String(propValue);
    if (propValue && !$66e9ff9cece0fdb5$var$isValidMaxNumber(propValue)) return new Error($66e9ff9cece0fdb5$var$getInvalidMaxError(strVal, componentName));
    return null;
  },
  value: function value(props, propName, componentName) {
    var valueProp = props[propName];
    var strVal = String(valueProp);
    var max = $66e9ff9cece0fdb5$var$isValidMaxNumber(props.max) ? props.max : $66e9ff9cece0fdb5$var$DEFAULT_MAX;
    if (valueProp != null && !$66e9ff9cece0fdb5$var$isValidValueNumber(valueProp, max)) return new Error($66e9ff9cece0fdb5$var$getInvalidValueError(strVal, componentName));
    return null;
  }
};
/* -------------------------------------------------------------------------------------------------
 * ProgressIndicator
 * -----------------------------------------------------------------------------------------------*/
var $66e9ff9cece0fdb5$var$INDICATOR_NAME = 'ProgressIndicator';
var $66e9ff9cece0fdb5$export$2b776f7e7ee60dbd = /*#__PURE__*/$1DGzP$react.forwardRef(function (props, forwardedRef) {
  var _context$value;
  var __scopeProgress = props.__scopeProgress,
    indicatorProps = _objectWithoutProperties(props, _excluded2);
  var context = $66e9ff9cece0fdb5$var$useProgressContext($66e9ff9cece0fdb5$var$INDICATOR_NAME, __scopeProgress);
  return /*#__PURE__*/$1DGzP$react.createElement($1DGzP$radixuireactprimitive.Primitive.div, $parcel$interopDefault($1DGzP$babelruntimehelpersextends)({
    "data-state": $66e9ff9cece0fdb5$var$getProgressState(context.value, context.max),
    "data-value": (_context$value = context.value) !== null && _context$value !== void 0 ? _context$value : undefined,
    "data-max": context.max
  }, indicatorProps, {
    ref: forwardedRef
  }));
});
/*#__PURE__*/
Object.assign($66e9ff9cece0fdb5$export$2b776f7e7ee60dbd, {
  displayName: $66e9ff9cece0fdb5$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */
function $66e9ff9cece0fdb5$var$defaultGetValueLabel(value, max) {
  return "".concat(Math.round(value / max * 100), "%");
}
function $66e9ff9cece0fdb5$var$getProgressState(value, maxValue) {
  return value == null ? 'indeterminate' : value === maxValue ? 'complete' : 'loading';
}
function $66e9ff9cece0fdb5$var$isNumber(value) {
  return typeof value === 'number';
}
function $66e9ff9cece0fdb5$var$isValidMaxNumber(max) {
  // prettier-ignore
  return $66e9ff9cece0fdb5$var$isNumber(max) && !isNaN(max) && max > 0;
}
function $66e9ff9cece0fdb5$var$isValidValueNumber(value, max) {
  // prettier-ignore
  return $66e9ff9cece0fdb5$var$isNumber(value) && !isNaN(value) && value <= max && value >= 0;
} // Split this out for clearer readability of the error message.
function $66e9ff9cece0fdb5$var$getInvalidMaxError(propValue, componentName) {
  return "Invalid prop `max` of value `".concat(propValue, "` supplied to `").concat(componentName, "`. Only numbers greater than 0 are valid max values. Defaulting to `").concat($66e9ff9cece0fdb5$var$DEFAULT_MAX, "`.");
}
function $66e9ff9cece0fdb5$var$getInvalidValueError(propValue, componentName) {
  return "Invalid prop `value` of value `".concat(propValue, "` supplied to `").concat(componentName, "`. The `value` prop must be:\n  - a positive number\n  - less than the value passed to `max` (or ").concat($66e9ff9cece0fdb5$var$DEFAULT_MAX, " if no `max` prop is set)\n  - `null` if the progress is indeterminate.\n\nDefaulting to `null`.");
}
var $66e9ff9cece0fdb5$export$be92b6f5f03c0fe9 = $66e9ff9cece0fdb5$export$b25a304ec7d746bb;
var $66e9ff9cece0fdb5$export$adb584737d712b70 = $66e9ff9cece0fdb5$export$2b776f7e7ee60dbd;